module.exports = __webpack_public_path__ + "static/media/logo-mutant-branco.94b79bb3.svg";